<template>
  <div class="LayoutDefault">
    <main class="LayoutDefault__main">
      <slot />
    </main>
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import vConsole from 'vconsole'
import env from '@/core/utils/env'
export default defineComponent({
  name: 'LayoutDownload',
  setup() {
    onMounted(() => {
      // eslint-disable-next-line new-cap
      if (env === 'testing' || env === 'pre') {
        // eslint-disable-next-line new-cap
        new vConsole()
      }
      const { documentElement } = document
      console.log(
        `current page width: ${documentElement.clientWidth}, current page height: ${documentElement.clientHeight}, dpr=${window.devicePixelRatio}`
      )
    })
  }
})
</script>
<style lang="scss">
@font-face {
  font-family: 'DINAlternate';
  src: url('https://gh.gtimg.com/fonts/din_alternate_bold-webfont.woff2') format('woff2'),
    url('https://gh.gtimg.com/fonts/din_alternate_bold-webfont.woff') format('woff');
}

@font-face {
  font-family: 'TTTGB';
  src: url('https://gh.gtimg.com/owhat/dist/fonts/Tencent-W7.ttf') format('truetype');
}

html {
  box-sizing: border-box;
}
*,
*:before,
*:after {
  box-sizing: inherit;
}
body * {
  user-select: none;
}
body,
html {
  margin: 0;
  padding: 0;
}

body.locked {
  overflow: hidden;
}
body input,
body textarea {
  user-select: text;
}
input[type='text'] {
  /* Remove First */
  appearance: none;
  appearance: none;
  appearance: none;
  outline: none;

  /* Then Style */
  border-radius: 15px;
  border: 1px dashed #bbb;
  padding: 10px;
  line-height: 20px;
  text-align: center;
  background: transparent;
}
img {
  display: block;
  width: 100%;
  max-width: 100%;
}
ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
a {
  color: inherit;
  text-decoration: none;
}
h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0;
}
.layout-default {
  &__env {
    position: fixed;
    left: 0px;
    bottom: 44px;
    border-radius: 3px;
    font-size: 12px;
    z-index: 9999;
    font-weight: 600;
    color: #f00;
    background: rgba(0, 0, 0, 0.5);
    padding: 5px;
  }
}
</style>
